import container from '@ioc';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IAuthenticationService$ } from '@services/auth/IAuthentication.interface';
import { ILoggingService$ } from '@services/logging/ILoggingService.interface';
import appConfig from '@src/app/config/appConfig';
import { getAustralianDate } from '@src/app/utils/GenericUtils';
import { PortfolioTransactions, IAuthenticationService, ILoggingService, PortfoliosServiceClient } from 'clientportalshared';
import { transactionsApiThunkPayload } from '../../constants';
import { GetTransactionsListRequest } from './types';

export const getTransactionsAsync = createAsyncThunk<PortfolioTransactions, GetTransactionsListRequest>(
  transactionsApiThunkPayload,
  async (payload: GetTransactionsListRequest) => {
    try {
      const authService = container.get<IAuthenticationService>(IAuthenticationService$);
      const loggingService = container.get<ILoggingService>(ILoggingService$);
      const portfoliosClient = new PortfoliosServiceClient(appConfig.apiEndpointUrl, authService, loggingService, appConfig);
      const result = await portfoliosClient.getMultiPortfolioTransactionsAsync(
        getAustralianDate(payload.fromDate),
        getAustralianDate(payload.toDate),
        payload.securityCode ?? null,
        payload.clientPortfolios
      );
      return result;
    } catch (e) {
      return {} as PortfolioTransactions;
    }
  }
);
